var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.274292,
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_290_345",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_290_345",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACkUlEQVR4nO2dO4sUQRRGz26gBiI+UEzUwMBXYGC6/gFBMFCMNBIRwdhIWDEwEzYSxcxMEATBxFSUBf0DPjODVRQFFRUtWexgmWCnZ6dn7+2tc+CmM/T3VX23u6iuBhEREREREREREWnDOaAMKZkQh4HvGhDDFuBNC/GdARNgGnjUUnwNmABXRxBfAzpiHXACuA/80YDV4wgwByyMKLozYAx2A5eBl2OIrgEjshk4CzwG/nYkvD1gCOuB48A94GfHomtAi1z/MEHRNWCAPU2uv1ol0TWA/0+r54EnE8h1DQjOdQ0YWBqYaXL9YwLBq4mg/cAs8DqByNUYsHVJrkcLW40BG5bk+q8EglZhwHST67eALwlErMaAg02uv00gXDUGbOthrvfegMVcPwU87Gmu99KApbn+NYEwpRYDDjW5/i6BGKWPBoz7B6XyGhsNQANKgpHsDCBeTCOIeEHtAfSrbMJoQPgoLM6AeCGKERQvRgkoewAaED4KizMgXohiBMWLUQLKHoAGhI/C4gyIF6IYQfFilICyB6AB4aOwOAPihShGULwYJaDsAWhA+CgsfZ4B4+LGrCS4NTERbs5NxE7gRoKsXrM9oA3XEwhVrQFTa3zndHpmEohUtQGzCUSq2oC5BCJVbcCFDi/2RwLBe/mW5KcOLnTxnIhNwOlkL//1gmMtT6Fdrm4O/OZ24BIwrwHtOADcBb6tULCjy/z2PuBa0O1u79gInGlOp/3d8iKfN88Tw5hqjLoNfNaA4exoYuTZMmItNCuuK1mPOgk88NC+duwFrgAvmn7xHrgD7KKbG4GLwFMjKB4Pbk2ERxcnwcO7e7x2JR3jBxwS4CdMEuBHfBKw+MRuDxAREREREREREdrwD51TO0BUkQqQAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.1da1361e9fff34b23dba1cd66e52bd07.svg";
export { ForwardRef as ReactComponent };